// extracted by mini-css-extract-plugin
module.exports = {"root":"Asset_root__y3Fuj","mobile":"Asset_mobile__k1Y_E","desktop":"Asset_desktop__cXrBX","video":"Asset_video__TeGX2"};